<div class="lmo-well-status-report">
  <h2>{{ frac$ | async | fracName }}</h2>
  <p>Report this well as Down if it is not in a scheduled plug and perf wireline run.</p>

  <form [formGroup]="reportForm" (ngSubmit)="createReport()">
    <mat-form-field>
      <mat-label>Available</mat-label>
      <mat-select formControlName="available" saAutomatedSelector="well_status__available">
        <mat-option [value]="true">Up</mat-option>
        <mat-option [value]="false">Down</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="reportForm.get('eta').enabled" [@fadeInAndOut]>
      <input
        type="number"
        matInput
        placeholder="Estimated Down Time (Hours)"
        formControlName="eta"
        autocomplete="off"
        saAutomatedSelector="well_status__eta"
      />
    </mat-form-field>

    <mat-form-field *ngIf="reportForm.get('description').enabled" [@fadeInAndOut]>
      <textarea
        matInput
        placeholder="Description"
        formControlName="description"
        autocomplete="off"
        saAutomatedSelector="well_status__description"
      ></textarea>
    </mat-form-field>

    <button mat-raised-button color="primary" saAutomatedSelector="well_status__create" [disabled]="isLoading">
      Create Report
    </button>
  </form>
</div>
